import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap'
import {HttpClientModule} from '@angular/common/http'
import { NotifierModule } from "angular-notifier";
import { DragDropModule, DragDropRegistry } from '@angular/cdk/drag-drop';
import { NgDragDropModule } from 'ng-drag-drop';
import { ChartsModule } from 'ng2-charts';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SubscriptionPromptComponent } from './subscription-prompt/subscription-prompt.component';
import { SuccessfulComponent } from './successful/successful.component';
import { PopupComponent } from './popup/popup.component';
import { AlterSubComponent } from './alter-sub/alter-sub.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { ViewportRuler, ScrollDispatcher } from '@angular/cdk/scrolling';
import { Platform } from '@angular/cdk/platform';
import { BreakdownComponent } from './breakdown/breakdown.component';

import {FormsModule} from '@angular/forms';
import { CheckoutComponent } from './checkout/checkout.component';




@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    SignupComponent,
    DashboardComponent,
    SubscriptionPromptComponent,
    SuccessfulComponent,
    PopupComponent,
    AlterSubComponent,
    AccountSettingsComponent,
    BreakdownComponent,
    CheckoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    NotifierModule,
    NgDragDropModule.forRoot(),
    DragDropModule,
    ChartsModule,
    FormsModule
  ],
  exports:[
  ],
  providers: [ViewportRuler,Platform,DragDropRegistry,ScrollDispatcher],
  bootstrap: [AppComponent]
})
export class AppModule { }
